// @ts-nocheck
import { scarpaGray100, spanishViridian500, strokesAAA } from '@habitech/shared';
import styled from 'styled-components';

export const WrapperTab = styled.div`
   height: 100%;
   margin: 48px 16px;
    .navTab{
        height: 64px;
        display: ruby-text;
        align-items: center;
        span{
            display: inline-block;
            height: 48px;
            line-height: 48px;
            padding: 0 10px;
            position: relative;
            color: ${strokesAAA};
            border-bottom: 2px solid ${scarpaGray100};
            button{
                background: none;
                border: none;
                color: ${strokesAAA};
                font-weight: bold;
                font-size: 16px;
                cursor: pointer;
                padding: 16px;
            }
            &.active > button{
                color: ${spanishViridian500};
            }
            &.active::before{
                content: '';
                position: absolute;
                width: 100%;
                height: 4px;
                background: ${spanishViridian500};
                bottom: -3px;
                left: 0;
                border-radius: 4px;
            }
        }
    }
    .mainTab{
        height: calc(100% - 80px);
        display :${props => props.tab ? 'none' : 'block'};
    }
    .headerTab {
        overflow: scroll hidden;
    }
    .headerTab::-webkit-scrollbar {
        width: 0px;
        height: 0px;
    }
    @media ${({ theme }) => theme.screenSizes.laptop} {
        .headerTab {
            overflow: hidden;
        }
    }
`;
